import styled from '@emotion/styled';
import { customProperties as vars } from '@resi-ui/design-system';

export const SpacerS = styled.div`
  height: ${vars.spacingS};
`;

export const SubmitButtonWrap = styled.div`
  margin-top: ${vars.spacingL};
`;

export const DataCenterDetailsWrap = styled.div`
  width: 180px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DataCenterHeader = styled.h3<{ timedOut?: boolean }>`
  font-weight: 600;
  font-size: ${vars.fontSize14};
  margin: 0;
  color: ${({ timedOut }): string => (timedOut ? vars.colorError : vars.colorAccent35)};
  margin-top: ${vars.spacingXs};
`;

export const MsText = styled.span<{ passing: boolean }>`
  color: ${({ passing }): string => (passing ? vars.colorSuccess : vars.colorError)};
`;

export const DataCenterDescription = styled.p<{ passing: boolean }>`
  font-size: ${vars.fontSize10};
  color: ${({ passing }): string => (passing ? vars.colorAccent55 : vars.colorError)};
  font-weight: normal;
  display: flex;
  align-items: center;
`;

export const Link = styled.a`
  color: ${vars.colorPrimary};
  cursor: pointer;
`;
